import React from 'react';
import { ApiAccessKeyReducer } from '@leverege/api-redux';
import { GlobalState, Select } from '@leverege/ui-redux';
import { Dialog, Toast } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import Icons from "../Icons.js";
const {
  t,
  tIcon
} = I18N.ns('apiAccessKeyManagement.apiAccessKey.RemoveApiAccessKeysDialog');
async function onRemoveApiAccessKeys({
  data
}) {
  // Get parameters
  const {
    targets,
    actions,
    dispatch,
    onClose
  } = data;

  // Try to remove api accesses
  try {
    await Promise.all(targets.map(target => dispatch(actions.apiAccessKey(target).delete())));
    await dispatch(Select.clear('apiAccessKeysTargeted'));
  } catch (error) {
    Toast.error(t(targets.length === 1 ? 'toastError_one' : 'toastError_other'));
    return onClose();
  }

  // Successfully removed api accesses
  Toast.success(t(targets.length === 1 ? 'toastSuccess_one' : 'toastSuccess_other'));
  return onClose();
}
export default function RemoveApiAccessKeysDialog(props) {
  const {
    resourceId,
    targets,
    onClose,
    show
  } = props;
  const name = ApiAccessKeyReducer.getApiAccessKey(GlobalState.get(), resourceId, targets[0])?.name;
  const count = targets.length;
  return /*#__PURE__*/React.createElement(Dialog.Question, {
    show: show,
    eventData: props,
    title: t(targets.length === 1 ? 'title_one' : 'title_other'),
    icon: tIcon('removeDialogIcon', Icons.apiAccessKeyRemoveDialogIcon),
    message: t(targets.length === 1 ? 'message_one' : 'message_other', targets.length === 1 ? {
      name
    } : {
      count
    }),
    cancel: t('cancelLabel'),
    okay: t('okayLabel'),
    okayVariant: "primaryDestructive",
    onCancel: onClose,
    onOkay: onRemoveApiAccessKeys
  });
}